import { AfterViewInit, Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { fromEvent } from 'rxjs';
import anime from 'animejs/lib/anime.es.js';
import { distinctUntilChanged } from 'rxjs/operators';
import { LangChangerService } from '../../shared/lang-changer/lang-changer.service';

const windowResized = fromEvent(window, 'resize');
const windowScrolled = fromEvent(window, 'scroll');

@Component({
  selector: 'app-headline',
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss']
})
export class HeadlineComponent implements OnInit, AfterViewInit {
  private os: String = '';
  private device: String = '';
  public osDetectable: Boolean = false;
  public currentLangCode: String = 'th';

  private mockupAnim: any;
  private confettiAnim: any;
  private headerHeight: number;
  @ViewChild('mockup', { static: false, read: ElementRef}) private mockupRef: ElementRef;
  @ViewChild('confetti', { static: false, read: ElementRef}) private confettiRef: ElementRef;
  @ViewChild('header', { static: false, read: ElementRef}) private headerRef: ElementRef;

  constructor(
    private deviceService: DeviceDetectorService,
    private langChangerService: LangChangerService
  ) {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.os = deviceInfo.os;
    this.device = deviceInfo.device;
    this.osDetectable = (this.deviceService.isMobile() || this.deviceService.isTablet())
                        && (this.os === 'Android' || this.os === 'iOS' || this.device === 'iPad');
  }

  ngOnInit() {
    this.currentLangCode = this.langChangerService.currentLangCode;
    this.langChangerService.currentLangCode$.subscribe(val => {
      this.currentLangCode = val;
    });
  }

  ngAfterViewInit() {
    this.headerHeight = this.headerRef.nativeElement.offsetHeight;
    this.mockupAnim = anime({
      targets: this.mockupRef.nativeElement,
      translateY: 100,
      easing: 'easeInOutSine',
      autoplay: false,
    });

    this.confettiAnim = anime({
      targets: this.confettiRef.nativeElement,
      translateY: 50,
      easing: 'easeInOutSine',
      autoplay: false,
    });

    windowResized
      .pipe(distinctUntilChanged())
      .subscribe((evt: Event) => {
        this.headerHeight = this.headerRef.nativeElement.offsetHeight;
      });

    windowScrolled
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        const scrollPosition = window.pageYOffset;
        this.mockupAnim.seek(Math.max(Math.min(scrollPosition / this.headerHeight, 1), 0) * this.mockupAnim.duration);
        this.confettiAnim.seek(Math.max(Math.min(scrollPosition / this.headerHeight, 1), 0) * this.confettiAnim.duration);
      });
  }

  downloadLink() {
    if (this.os === 'iOS' || this.device === 'iPad') {
      return 'https://itunes.apple.com/th/app/viabus/id1074208600';
    } else {
      return 'https://play.google.com/store/apps/details?id=com.indyzalab.transitia';
    }
  }
}
